import {useQuery} from "react-query";
import {useParams} from "react-router-dom";
import api from "../services/api";
import queryClient from "../services/queryClient";
import {useRecoilValue} from "recoil";
import {spaceIdState} from "../state/spaceState";

const fetchStats = (timing) => {
    return api.get(`/timings/${timing}/stats`).then(response => response.data && response.data.data);
}

const useFetchStats = () => {
    const id = useRecoilValue(spaceIdState);

    return useQuery([id, 'stats'], () => fetchStats(id), {
        refetchIntervalInBackground: true,
        refetchInterval: 10*1000,
        enabled: !!id,
    });
};

export default useFetchStats;
